import { Component, OnInit, ViewChild } from '@angular/core';
import { DateTimeAdapter, OWL_DATE_TIME_FORMATS, OWL_DATE_TIME_LOCALE } from 'ng-pick-datetime';
import { MomentDateTimeAdapter } from 'ng-pick-datetime-moment';
import { FilterPipePipe } from '../../pipes/filter-pipe.pipe';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { CommonService } from '../../core/service/common-service/common.service';
import { ToastrService } from 'ngx-toastr';
import { MatTableDataSource, MatSort, MatPaginator, MatSelect, MatOption } from '@angular/material';
import { FormControl, FormBuilder, FormGroup } from '@angular/forms';

export const MY_CUSTOM_FORMATS = {
  parseInput: 'LL LT',
  fullPickerInput: 'DD-MM-YYYY LT',
  datePickerInput: 'DD-MM-YYYY',
  timePickerInput: 'LT',
  monthYearLabel: 'MMM YYYY',
  dateA11yLabel: 'LL',
  monthYearA11yLabel: 'MMMM YYYY',
};

@Component({
  selector: 'app-market-share-reporting',
  templateUrl: './market-share-reporting.component.html',
  styleUrls: ['./market-share-reporting.component.scss'],
  providers: [
    { provide: DateTimeAdapter, useClass: MomentDateTimeAdapter, deps: [OWL_DATE_TIME_LOCALE] },
    { provide: OWL_DATE_TIME_FORMATS, useValue: MY_CUSTOM_FORMATS },
    FilterPipePipe
  ],
})
export class MarketShareReportingComponent implements OnInit {

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild('allSelectedRegion', { static: true }) private allSelectedRegion: MatOption;
  @ViewChild('allSelectedWorkshopCode', { static: true }) private allSelectedWorkshopCode: MatOption;
  @ViewChild('allSelectedServiceType', { static: true }) private allSelectedServiceType: MatOption;
  @ViewChild('allSelectedLostAge', { static: true }) private allSelectedLostAge: MatOption;
  @ViewChild('allSelectedVehicleAge', { static: true }) private allSelectedVehicleAge: MatOption;

  uniqueLostAge: any[] = [
    {key: "0-1", value: "0-1"},
    {key: "1-2", value: "1-2"},
    {key: "2-3", value: "2-3"},
    {key: "3-4", value: "3-4"},
    {key: "4-5", value: "4-5"},
    {key: "5-6", value: "5-6"},
    {key: "6-7", value: "6-7"},
    {key: "7-8", value: "7-8"}
  ];

  uniqueVehicleAge: any[] = [
    {key: "0-1", value: "0-1"},
    {key: "1-2", value: "1-2"},
    {key: "2-3", value: "2-3"},
    {key: "3-4", value: "3-4"},
    {key: "4-5", value: "4-5"},
    {key: "5-6", value: "5-6"},
    {key: "6-7", value: "6-7"},
    {key: "7-8", value: "7-8"}
  ];

  uniqueServiceTypeValue: any[] = [
    {key: "1", value: "ECS - Early Care Service"},
    {key: "3", value: "PMS - Preventive Maintenance Service"},
    // {key: "21,22,23", value: "FS - Free Service"},
    {key: "21", value: "FS - Free Service 1"},
    {key: "22", value: "FS - Free Service 2"},
    {key: "23", value: "FS - Free Service 3"},
  ];

  spinner: boolean;
  userId: string;
  userInfo: any;
  today: Date = new Date();
  toDate: Date;
  fromDate: Date;
  isDateRangeInvalid = false;
  uniqueRegionValue: string[] = [];
  uniqueWorkshopCodeValue: string[] = [];
  //uniqueServiceTypeValue: string[] = [];
  selectedRegionValues: string[] = [];
  selectedWorkshopValues: string[] = [];
  selectedLostAgeValues: string[] = [];
  selectedVehicleAgeValues: string[] = [];
  selectedServiceTypeValues: string[] = [];
  selectRegion: FormGroup;
  selectWorkshop: FormGroup;
  selectServiceType: FormGroup;
  selectLostAge: FormGroup;
  selectVehicleAge: FormGroup;
  workshopCodeType: any;
  uniqueWorkshopCodeValueCopy: string[] = [];
  selectedDealer:any;
  dealerCode: string[] = [];
  maxDate: Date = new Date();

  constructor(
    private router: Router,
    private datePipe: DatePipe,
    private commonService: CommonService,
    private toastr: ToastrService,
    private filterPipePipe: FilterPipePipe,
    private fb: FormBuilder
    ) { }

  ngOnInit() {
    this.setDefaultDates();
    this.userId = localStorage.getItem('userId');
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
    if (localStorage.getItem('userId') == null || localStorage.getItem('userId') == undefined) {
      this.router.navigate(['login']);
    }

    this.selectRegion = this.fb.group({
      regionType: ['']
    });

    this.selectWorkshop = this.fb.group({
      workshopCodeType: [''],
      selectedDealer: ['']
    });

    this.selectServiceType = this.fb.group({
      serviceTypeValue: ['']
    });

    this.selectLostAge = this.fb.group({
      lostAgeType: ['']
    });

    this.selectVehicleAge = this.fb.group({
      vehicleAgeType: ['']
    });

    this.getRegion();
    this.getWorkshopCode();
  }

  /**
  * Name: getRegion
  * purpose: To get region value
  */
  getRegion() {
    this.spinner = true;
    this.commonService.getRegionValue()
      .subscribe(res => {
        if (res['responseCode'] == 0 && res['responseData'] != undefined) {
          if (res['responseData'].length) {
            res['responseData'].forEach(element => {
              this.uniqueRegionValue.push(element.workshopRegion);
            });
            //this.selectedRegionValues = this.uniqueRegionValue[0];
            this.spinner = false;
          }
        } else {
          this.spinner = false;
          this.toastr.error(res['message'], "Error");
        }
      }, err => {
        this.spinner = false;
        this.toastr.error("Something went wrong, Please try again.", "Error");
      });
  }

  /**
   * Name: filterTriggered
   * @param {Event} event - region filter data
   * purpose: To set dealer code filter values
   */
  filterTriggered(event: any): void {
    this.uniqueWorkshopCodeValue = [];
    //this.selectWorkshop.setValue({workshopCodeType:''});
    let value;
    if(this.selectRegion.value.regionType == "0") {
      value = '';
    } else {
      value = this.selectRegion.value.regionType.toString();
    }
    this.commonService.getMSDealerCode(value)
    .subscribe(res => {
      if (res['responseCode'] == 0 && res['responseData'] != undefined) {
        if (res['responseData'].length) {
          res['responseData'].forEach(element => {
            this.uniqueWorkshopCodeValue.push(element.workshopCode);
          });
          this.uniqueWorkshopCodeValueCopy = this.uniqueWorkshopCodeValue;
          this.spinner = false;
        }
      } else {
        this.spinner = false;
        this.toastr.error(res['message'], "Error");
      }
    }, err => {
      this.spinner = false;
      this.toastr.error("Something went wrong, Please try again.", "Error");
    });
  }

  /**
  * Name: getLeadExcelReport
  * purpose: To export Lead Data report as excel
  */
  getLeadExcelReport() {
    if (this.isDateRangeInvalid) {
      this.toastr.error("Please select dates within a 30-day range to proceed.", "Error");
      return;
    }
    this.spinner = true;
    if(this.selectRegion.value.regionType != ""){
      this.selectRegion.value.regionType.forEach((element,index)=>{
        if(element == "0"){
          this.selectRegion.value.regionType.splice(index,1);
        }
      });
    }
    if(this.selectWorkshop.value.workshopCodeType != ""){
      this.selectWorkshop.value.workshopCodeType.forEach((element,index)=>{
        if(element == "0"){
          this.selectWorkshop.value.workshopCodeType.splice(index,1);
        }
      });
    }
    if(this.selectServiceType.value.serviceTypeValue != ""){
      this.selectServiceType.value.serviceTypeValue.forEach((element,index)=>{
        if(element == "0"){
          this.selectServiceType.value.serviceTypeValue.splice(index,1);
        }
      });
    }
    if(this.selectLostAge.value.lostAgeType != ""){
      this.selectLostAge.value.lostAgeType.forEach((element,index)=>{
        if(element == "0"){
          this.selectLostAge.value.lostAgeType.splice(index,1);
        }
      });
    }
    if(this.selectVehicleAge.value.vehicleAgeType != ""){
      this.selectVehicleAge.value.vehicleAgeType.forEach((element,index)=>{
        if(element == "0"){
          this.selectVehicleAge.value.vehicleAgeType.splice(index,1);
        }
      });
    }
    let request = {
      region: this.selectRegion.value.regionType.toString(),
      workshopCode: this.selectWorkshop.value.workshopCodeType.toString(),
      serviceTypeCode: this.selectServiceType.value.serviceTypeValue.toString(),
      startDate: this.datePipe.transform(this.fromDate, "yyyy-MM-dd"),
      endDate: this.datePipe.transform(this.toDate, "yyyy-MM-dd"),
      vehicalAge: this.selectVehicleAge.value.vehicleAgeType.toString(),
      lostCust: this.selectLostAge.value.lostAgeType.toString(),
      userId: this.userId
    };

    let startDate = this.datePipe.transform(this.fromDate, "yyyy-MM-dd");
    let endDate = this.datePipe.transform(this.toDate, "yyyy-MM-dd");

    let fileName = "Lead Status Report_From_" + startDate + "_To_" + endDate;
    this.commonService.getLeadExcelReport(request)
      .subscribe(fileData => {
        if (fileData) {
          const blob: any = new Blob([fileData], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          let link = document.createElement("a");
          if (link.download !== undefined) {
            let url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            this.spinner = false;
          }
        } else {
          this.spinner = false;
        }
      }, err => {
        this.spinner = false;
      });
  }

  /**
  * Name: getMarketShareReport
  * purpose: To export Market Share Data report as excel
  */
  getMarketShareReport() {
    if (this.isDateRangeInvalid) {
      this.toastr.error("Please select dates within a 30-day range to proceed.", "Error");
      return;
    }
    this.spinner = true;
    if(this.selectRegion.value.regionType != ""){
      this.selectRegion.value.regionType.forEach((element,index)=>{
        if(element == "0"){
          this.selectRegion.value.regionType.splice(index,1);
        }
      });
    }
    if(this.selectWorkshop.value.workshopCodeType != ""){
      this.selectWorkshop.value.workshopCodeType.forEach((element,index)=>{
        if(element == "0"){
          this.selectWorkshop.value.workshopCodeType.splice(index,1);
        }
      });
    }
    if(this.selectServiceType.value.serviceTypeValue != ""){
      this.selectServiceType.value.serviceTypeValue.forEach((element,index)=>{
        if(element == "0"){
          this.selectServiceType.value.serviceTypeValue.splice(index,1);
        }
      });
    }
    if(this.selectLostAge.value.lostAgeType != ""){
      this.selectLostAge.value.lostAgeType.forEach((element,index)=>{
        if(element == "0"){
          this.selectLostAge.value.lostAgeType.splice(index,1);
        }
      });
    }
    if(this.selectVehicleAge.value.vehicleAgeType != ""){
      this.selectVehicleAge.value.vehicleAgeType.forEach((element,index)=>{
        if(element == "0"){
          this.selectVehicleAge.value.vehicleAgeType.splice(index,1);
        }
      });
    }
    let request = {
      region: this.selectRegion.value.regionType.toString(),
      workshopCode: this.selectWorkshop.value.workshopCodeType.toString(),
      serviceTypeCode: this.selectServiceType.value.serviceTypeValue.toString(),
      startDate: this.datePipe.transform(this.fromDate, "yyyy-MM-dd"),
      endDate: this.datePipe.transform(this.toDate, "yyyy-MM-dd"),
      vehicalAge: this.selectVehicleAge.value.vehicleAgeType.toString(),
      lostCust: this.selectLostAge.value.lostAgeType.toString(),
      userId: this.userId
    };

    let startDate = this.datePipe.transform(this.fromDate, "yyyy-MM-dd");
    let endDate = this.datePipe.transform(this.toDate, "yyyy-MM-dd");
    let fileName = "Market Share Report_From_" + startDate + "_To_" + endDate;
    this.commonService.getMarketShareReport(request)
      .subscribe(fileData => {
        if (fileData) {
          const blob: any = new Blob([fileData], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          let link = document.createElement("a");
          if (link.download !== undefined) {
            let url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            this.spinner = false;
          }
        } else {
          this.spinner = false;
        }
      }, err => {
        this.spinner = false;
      });
  }

  getWorkshopCode(){
    this.spinner = true;
    this.commonService.getMSDealerCode('')
      .subscribe(res => {
        if (res['responseCode'] == 0 && res['responseData'] != undefined) {
          if (res['responseData'].length) {
            res['responseData'].forEach(element => {
              this.uniqueWorkshopCodeValue.push(element.workshopCode);
            });
            this.uniqueWorkshopCodeValueCopy = this.uniqueWorkshopCodeValue;
            this.spinner = false;
          }
        } else {
          this.spinner = false;
          this.toastr.error(res['message'], "Error");
        }
      }, err => {
        this.spinner = false;
        this.toastr.error("Something went wrong, Please try again.", "Error");
      });
  }

  /**
  * Name: toggleAllSelectionRegion
  * purpose: To select/remove all data in workshop drop down
  */
  toggleAllSelectionRegion(): void {
    if (this.allSelectedRegion.selected) {
      this.selectRegion.controls.regionType.patchValue([...this.uniqueRegionValue, 0]);
    } else {
      this.selectRegion.controls.regionType.patchValue([]);
    }
  }

  tosslePerOneRegion() {
    if (this.allSelectedRegion.selected) {
      this.allSelectedRegion.deselect();
      return false;
    }

    if (this.selectRegion.controls.regionType.value.length == this.uniqueRegionValue.length) {
      this.allSelectedRegion.select();
    }
  }

  /**
  * Name: toggleAllSelectionWorkshopCode
  * purpose: To select/remove all data in workshop drop down
  */
  toggleAllSelectionWorkshopCode(): void {
    if (this.allSelectedWorkshopCode.selected) {
      this.selectWorkshop.controls.workshopCodeType.patchValue([...this.uniqueWorkshopCodeValue, 0]);
    } else {
      this.selectWorkshop.controls.workshopCodeType.patchValue([]);
    }
  }

  tosslePerOneWorkshopCode() {
    if (this.allSelectedWorkshopCode.selected) {
      this.allSelectedWorkshopCode.deselect();
      return false;
    }

    if (this.selectWorkshop.controls.workshopCodeType.value.length == this.uniqueWorkshopCodeValue.length) {
      this.allSelectedWorkshopCode.select();
    }
  }

  /**
  * Name: toggleAllSelectionServiceType
  * purpose: To select/remove all data in workshop drop down
  */
  toggleAllSelectionServiceType(): void {
    if (this.allSelectedServiceType.selected) {
      this.selectServiceType.controls.serviceTypeValue.patchValue([...this.uniqueServiceTypeValue.map(item => item.key), 0]);
    } else {
      this.selectServiceType.controls.serviceTypeValue.patchValue([]);
    }
  }


  tosslePerOneServiceType() {
    if (this.allSelectedServiceType.selected) {
      this.allSelectedServiceType.deselect();
      return false;
    }

    if (this.selectServiceType.controls.serviceTypeValue.value.length == this.uniqueServiceTypeValue.length) {
      this.allSelectedServiceType.select();
    }
  }

  /**
  * Name: toggleAllSelectionLostAge
  * purpose: To select/remove all data in workshop drop down
  */
  toggleAllSelectionLostAge(): void {
    if (this.allSelectedLostAge.selected) {
      this.selectLostAge.controls.lostAgeType.patchValue([...this.uniqueLostAge.map(item => item.key), 0]);
    } else {
      this.selectLostAge.controls.lostAgeType.patchValue([]);
    }
  }


  tosslePerOneLostAge() {
    if (this.allSelectedLostAge.selected) {
      this.allSelectedLostAge.deselect();
      return false;
    }

    if (this.selectLostAge.controls.lostAgeType.value.length == this.uniqueLostAge.length) {
      this.allSelectedLostAge.select();
    }
  }

  /**
  * Name: toggleAllSelectionVehicleAge
  * purpose: To select/remove all data in workshop drop down
  */
  toggleAllSelectionVehicleAge(): void {
    if (this.allSelectedVehicleAge.selected) {
      this.selectVehicleAge.controls.vehicleAgeType.patchValue([...this.uniqueVehicleAge.map(item => item.key), 0]);
    } else {
      this.selectVehicleAge.controls.vehicleAgeType.patchValue([]);
    }
  }

  tosslePerOneVehicleAge() {
    if (this.allSelectedVehicleAge.selected) {
      this.allSelectedVehicleAge.deselect();
      return false;
    }

    if (this.selectVehicleAge.controls.vehicleAgeType.value.length == this.uniqueVehicleAge.length) {
      this.allSelectedVehicleAge.select();
    }
  }

  onKey() : void {
    this.uniqueWorkshopCodeValue = this.uniqueWorkshopCodeValueCopy;
    this.dealerCode = [];
    this.selectedDealer = this.selectWorkshop.controls.selectedDealer.value;
    this.selectedDealer = this.selectedDealer.toString();
    this.dealerCode = this.uniqueWorkshopCodeValue.filter(item =>
      item.toLowerCase().includes(this.selectedDealer.toLowerCase())
    );
    if(this.dealerCode.length > 0){
      this.closeInput();
    }
    this.uniqueWorkshopCodeValue = [];
    this.uniqueWorkshopCodeValue = this.dealerCode;
  }

  closeInput() : void {
    if(this.dealerCode.length == 0) {
     //this.selectedDealer = '';
     this.selectWorkshop.controls['selectedDealer'].setValue("");
     this.uniqueWorkshopCodeValue = this.uniqueWorkshopCodeValueCopy;
    }
  }

  dateFilterTriggered(event: any): void {
    this.today = new Date();
    if((new Date(new Date(event.source.value).getTime()+(1000*60*60*24*30))).getTime() >= this.today.getTime()){
      this.today = new Date();
      if((new Date(new Date(event.source.value).getTime()+(1000*60*60*24*30))).getTime() >= this.today.getTime()){
        this.toDate = new Date();
      } else {
         this.toDate = new Date(new Date(event.source.value).getTime()+(1000*60*60*24*30));
      }
    } else {
      this.today = new Date(new Date(event.source.value).getTime()+(1000*60*60*24*30));
      this.toDate = new Date(new Date(event.source.value).getTime()+(1000*60*60*24*30));
    }
  }
  setDefaultDates() {
    const current = new Date();
    this.fromDate = new Date(current.getFullYear(), current.getMonth(), 1); // 1st of current month
    this.toDate = this.today; // Today's date
  }

  // Validate the date range to restrict to 30 days
  validateDateRange(type: 'from' | 'to') {
    const thirtyDaysInMs = 30 * 24 * 60 * 60 * 1000;
    this.isDateRangeInvalid = false;
    this.fromDate = new Date(this.fromDate);
    this.toDate = new Date(this.toDate);
    if (type === 'from') {
      const maxToDate = new Date(this.fromDate.getTime() + thirtyDaysInMs);
      if (this.toDate.getTime() > maxToDate.getTime()) {
        this.isDateRangeInvalid = true;
      } else {
        this.isDateRangeInvalid = false;
      }
    } else if (type === 'to') {
      const minFromDate = new Date(this.toDate.getTime() - thirtyDaysInMs);
      if (this.fromDate.getTime() < minFromDate.getTime()) {
        this.isDateRangeInvalid = true;
      } else {
        this.isDateRangeInvalid = false;
      }
    }
  }
}